export default function Sug4(){
    return(
        <>
         <div className="col-md-6 mt-3">
      <div className="card">
        <div className="card-header">
          <h5>
            <span className="numero"></span>4 - Sensores vestíveis para monitoramento contínuo de saúde baseado em IoT 
          </h5>
        </div>
        <div className="card-body">
          <p className="card-text">Internet das coisas é um conceito baseado na interconexão de dispositivos chamados "Smart", como smart watches, Smart bands, através da internet.
	Atualmente, a área de IoT é utilizada em diversos campos como agricultura, automação residencial, controle de tráfego, smart grid, etc. A área healthcare é uma das que apresentam
		maior expansão, principalmente aplicada com monitoramento do estado de saúde de pacientes em tempo real. Baseado nisso, buscamos realizar pesquisas com diferentes sensores vestíveis que permitam o monitoramento contínuo de sinais bioelétricos através da internet.  </p> 

      
        </div>

        <ul className="list-group list-group-flush">
          <li className="list-group-item text-muted">
            <a href="../docs/farahani2017.pdf" target="_blank">Artigo - Towards fog-driven IoT eHealth: Promises and challenges of IoT in
medicine and healthcare</a>
          </li>
        </ul>
      </div>
    </div>
        </>
    )
}